// extracted by mini-css-extract-plugin
export default {"container":"AnimatedBackground_container__xwvQt","fluidBg":"AnimatedBackground_fluidBg__AcpXs","content":"AnimatedBackground_content__VDZyf"};